import script from "./FormUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormUpload.vue?vue&type=script&setup=true&lang=ts"

import "./FormUpload.vue?vue&type=style&index=0&id=fdb54514&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdb54514"]])

export default __exports__